import { render, staticRenderFns } from "./model2.vue?vue&type=template&id=61223b91&scoped=true"
import script from "./model2.vue?vue&type=script&lang=js"
export * from "./model2.vue?vue&type=script&lang=js"
import style0 from "./model2.vue?vue&type=style&index=0&id=61223b91&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "61223b91",
  null
  
)

export default component.exports